import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AccountStatus {
  isUnlimited: boolean;
  hasUnlimitedUploads: boolean;
  hasUnlimitedAnalyzes: boolean;
  hasUnlimitedStorage: boolean;
  uploadInitialAmount: number;
  analyzeInitialAmount: number;
  storageQuota: number;
  lastUpdated: number;
}

const initialState: AccountStatus = {
  isUnlimited: false,
  hasUnlimitedUploads: false,
  hasUnlimitedAnalyzes: false,
  hasUnlimitedStorage: false,
  uploadInitialAmount: 0,
  analyzeInitialAmount: 0,
  storageQuota: 0,
  lastUpdated: 0,
};

const accountStatusSlice = createSlice({
  name: "accountStatus",
  initialState,
  reducers: {
    updateAccountStatus: (state, action: PayloadAction<{
      uploadInitialAmount: number;
      analyzeInitialAmount: number;
      storageQuota: number;
    }>) => {
      const { uploadInitialAmount, analyzeInitialAmount, storageQuota } = action.payload;
      
      state.uploadInitialAmount = uploadInitialAmount;
      state.analyzeInitialAmount = analyzeInitialAmount;
      state.storageQuota = storageQuota;
      
      // Calculate unlimited status
      state.hasUnlimitedUploads = uploadInitialAmount > 999999;
      state.hasUnlimitedAnalyzes = analyzeInitialAmount > 999999;
      state.hasUnlimitedStorage = parseInt(storageQuota.toString()) > (1024 * 1024 * 1024 * 1024 * 10000); // 10,000 TB
      
      // Unlimited status requires all three to be unlimited
      state.isUnlimited = state.hasUnlimitedUploads && state.hasUnlimitedAnalyzes && state.hasUnlimitedStorage;
      
      state.lastUpdated = Date.now();
    },
    clearAccountStatus: (state) => {
      state.isUnlimited = false;
      state.hasUnlimitedUploads = false;
      state.hasUnlimitedAnalyzes = false;
      state.hasUnlimitedStorage = false;
      state.uploadInitialAmount = 0;
      state.analyzeInitialAmount = 0;
      state.storageQuota = 0;
      state.lastUpdated = 0;
    },
  },
});

export const { updateAccountStatus, clearAccountStatus } = accountStatusSlice.actions;
export default accountStatusSlice.reducer;
